import { PrismaticEmbed } from 'components/gms/PrismaticEmbed';
import { showLogs } from 'services/prismaticService';

export const IntegrationsLogs = () => (
  <PrismaticEmbed embedFunction={showLogs} containerId="prismatic-logs" />
);
